import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from "@angular/core";
import { interpolatePosition, interpolatePath } from "./marker-animation.util";
import { Router } from "@angular/router";
import * as L from "leaflet";
import "leaflet.markercluster";
import { AppsService } from "src/app/shared/services/apps.service";
import { PermissionService } from "src/app/services/permission.service";

import { DatePipe } from "@angular/common";
// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { CstmSocketIOService } from "src/app/providers/socket-io.service";

@Component({
  selector: "app-alerts-dashboard",
  templateUrl: "./alerts-dashboard.component.html",
  styleUrls: ["./alerts-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AlertsDashboardComponent implements OnInit {
  vehicleMarkerMap: any = {};
  lastVehicleApiPosition: any = {};
  hasFitBounds = false;

  alertCategories = [
    {
      alert_cat_id: 2,
      icon: "clock-circle",
      color: "#8e44ad",
      label: "Delay",
      visible: true,
    },
    {
      alert_cat_id: 22,
      icon: "compass",
      color: "#34495e",
      label: "GPS Not Reporting",
      visible: true,
    },
    {
      alert_cat_id: 8,
      icon: "field-time",
      color: "#2ecc71",
      label: "Late Departure",
      visible: true,
    },
    {
      alert_cat_id: 5,
      icon: "dashboard",
      color: "#e74c3c",
      label: "Overspeed",
      visible: true,
    },
    {
      alert_cat_id: 4,
      icon: "swap-right",
      color: "#2980b9",
      label: "Deviation",
      visible: true,
    },
    {
      alert_cat_id: 23,
      icon: "exclamation-circle",
      color: "#f39c12",
      label: "Unauthorized Movement",
      visible: true,
    },
    {
      alert_cat_id: 21,
      icon: "pause-circle",
      color: "#f39c12",
      label: "Vehicle Stoppage",
      visible: true,
    },
    // Add more as needed
  ];
  refresh_tm: string = "";
  header_label = {
    name: "CCC Monitoring Dashboard",
  };
  showLdr;
  // True while the changeReason PUT is in flight — prevents duplicate submits.
  isSavingRsn = false;
  clntDtls: any;
  userDtls: any;
  // View toggle state
  showTablesOnly = true;
  showMapOnly = false;
  tntLst: any = [];
  wardLst: any = [];
  selectedtenants: any;
  selectedward: any;
  selectedalert;
  map;
  // private markerClusterGroup: L.MarkerClusterGroup | undefined;
  private regionPolygon: L.Polygon | undefined;
  private regionPolygon2: L.Polygon | undefined;
  AlertTypeLst: any = [];
  curdate = new Date();
  strtdVehiclesDatacolumnDefs: any = [];
  othrVehDatacolumnDefs: any = [];
  startedVehiclesData: any = [];
  alertsData: any = [];
  unAuthVehData: any = [];
  unAuthVehDatacolumnDefs: any = [];
  othrVehData: any = [];
  mapData: any = [];
  // For animated marker previous positions
  m_prv_lat: { [asrt_id: number]: number } = {};
  m_prv_lng: { [asrt_id: number]: number } = {};
  vehicleMarkers: any[] = [];
  private socketInterval: any;
  regionBoundary;
  vehicleMarkerGroup;

  // Demo zone boundaries (polygons) and markers
  // regionBoundary: [number, number][] = [
  //   [28.679079, 77.432239],
  //   [28.686079, 77.442239],
  //   [28.682079, 77.452239],
  //   [28.673079, 77.447239],
  //   [28.679079, 77.432239]
  // ];
  // regionBoundary2: [number, number][] = [
  //   [28.675079, 77.435239],
  //   [28.678079, 77.438239],
  //   [28.676079, 77.445239],
  //   [28.672079, 77.442239],
  //   [28.675079, 77.435239]
  // ];
  // demoMarkers = [
  //   { lat: 28.682079, lng: 77.442239, label: 'RJ14PT3952', status: 'Stopage', icon: 'pause-circle', color: '#e74c3c' },
  //   { lat: 28.684079, lng: 77.435239, label: 'RJ14PT3920', status: 'Overspeed', icon: 'dashboard', color: '#f39c12' },
  //   { lat: 28.678079, lng: 77.445239, label: 'RJ14PT3289', status: 'Deviation', icon: 'swap-right', color: '#2980b9' },
  //   { lat: 28.680079, lng: 77.448239, label: 'RJ14PT4105', status: 'Started', icon: 'check-circle', color: '#52c41a' },
  //   { lat: 28.681079, lng: 77.439239, label: 'RJ14PT3793', status: 'OFF', icon: 'poweroff', color: '#888' }
  // ];
  columnDefs: {}[];
  unAuthcolumnDefs: {}[];
  selectedLayer: "street" | "osm" | "sat" = "street";
  baseLayers: any = {};
  currentBaseLayer: any = null;
  showLayerCard = false;

  constructor(
    public apiServ: AppsService,
    private datePipe: DatePipe,
    private modal: NzModalService,
    private message: NzMessageService,
    private socketService: CstmSocketIOService,
    public perms: PermissionService
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.selectedtenants = this.tntLst[0].tnt_id;
  }
  ngOnInit(): void {
    this.setRefreshTime();
    setInterval(() => this.setRefreshTime(), 1000);
    this.getWrds(this.selectedtenants);
    this.getAlertTypeLst();
    this.getAlertData();
    this.getStartedVehiclesData();
    this.getothrVehclData();
    this.getUnauthorizedVehiclesData();
    // if (!this.showTablesOnly) {
    setTimeout(() => this.initMap(), 300);
    // }

    // Start socket alerts every 30 seconds
    setTimeout(() => {
      this.getAlertsOnMap(); // Call immediately
    }, 1000);
    this.socketInterval = setInterval(() => {
      this.getAlertsOnMap();
    }, 10000); // 10000 ms = 10 seconds
  }

  setRefreshTime() {
    const now = new Date();
    this.refresh_tm = this.datePipe.transform(now, "HH:mm:ss");
  }

  // ngAfterViewInit(): void {

  // }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['showMapOnly'] || changes['showTablesOnly']) {
  //     setTimeout(() => this.refreshMap(), 0);
  //   }
  // }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
      this.map = undefined;
    }

    // Clean up socket interval
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
    }
  }

  refreshMap() {
    if (this.map) {
      this.map.invalidateSize();
    } else if (!this.showTablesOnly) {
      this.initMap();
    }
  }
  setMapLayer(layer: "street" | "osm" | "sat") {
    if (!this.map || !this.baseLayers[layer]) return;
    if (this.currentBaseLayer) {
      this.map.removeLayer(this.currentBaseLayer);
    }
    this.baseLayers[layer].addTo(this.map);
    this.currentBaseLayer = this.baseLayers[layer];
    this.selectedLayer = layer;
    this.showLayerCard = false;
  }
  initMap() {
    this.userDtls = JSON.parse(localStorage.getItem("wto_clients"));
    try {
      // Remove old map instance if exists
      if (this.map) {
        this.map.remove();
        this.map = undefined;
      }
      const mapDiv = document.getElementById("alertsMap");
      if (!mapDiv) {
        setTimeout(() => this.initMap(), 100);
        return;
      }
      // Only initialize if not already present
      if (!this.map) {
        this.map = L.map("alertsMap", {
          center: [this.userDtls[0].lat, this.userDtls[0].lng],
          zoom: 13,
          fullscreenControl: true,
        });
        // Define base layers
        const googleStreets = L.tileLayer(
          "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
          {
            maxZoom: 20,
            minZoom: 3,
            subdomains: ["mt0", "mt1", "mt2", "mt3"],
            attribution: "Google Streets",
          }
        );
        const osm = L.tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          {
            maxZoom: 20,
            minZoom: 13,
            attribution: "OpenStreetMap contributors",
          }
        );
        const googleSat = L.tileLayer(
          "http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
          {
            maxZoom: 20,
            minZoom: 13,
            subdomains: ["mt0", "mt1", "mt2", "mt3"],
            attribution: "Google Satellite",
          }
        );
        this.baseLayers = { street: googleStreets, osm: osm, sat: googleSat };
        googleStreets.addTo(this.map);
        this.currentBaseLayer = googleStreets;
        this.selectedLayer = "street";
        this.setMapLayer(this.selectedLayer);
        this.vehicleMarkerGroup = L.layerGroup().addTo(this.map);
        this.map.invalidateSize();
        this.getAlertsOnMap();
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleView(view: "tables" | "map" | "split") {
    if (view === "tables") {
      this.showTablesOnly = true;
      this.showMapOnly = false;
      if (this.map) {
        this.map.remove();
        this.map = undefined;
      }
    } else if (view === "map") {
      this.showMapOnly = true;
      this.showTablesOnly = false;
      this.hasFitBounds = false;
      if (this.map) {
        this.map.remove();
        this.map = undefined;
      }
      setTimeout(() => this.initMap(), 100);
    } else if (view === "split") {
      this.showMapOnly = false;
      this.showTablesOnly = false;
      this.hasFitBounds = false;
      if (this.map) {
        this.map.remove();
        this.map = undefined;
      }
      setTimeout(() => this.initMap(), 100);
    }
  }
  // Alerts Table Data
  // alertsData = [
  //   { vehicleNumber: 'RJ14AB1234', route: 'Zone 1 - Route A', alertType: 'Stopage', reason: 'Traffic', timestamp: '07:10 AM' },
  //   { vehicleNumber: 'RJ14AB5678', route: 'Zone 2 - Route B', alertType: 'Overspeed', reason: 'Route Issue', timestamp: '07:15 AM' },
  //   { vehicleNumber: 'RJ14CD4321', route: 'Zone 3 - Route C', alertType: 'Deviation', reason: 'Other', timestamp: '07:20 AM' },
  //   { vehicleNumber: 'RJ14CD8765', route: 'Zone 1 - Route D', alertType: 'Stopage', reason: '', timestamp: '07:25 AM' },
  //   { vehicleNumber: 'RJ14EF9999', route: 'Zone 2 - Route E', alertType: 'Overspeed', reason: '', timestamp: '07:30 AM' }
  // ];
  // // Started Vehicles Table Data
  // startedVehiclesData = [
  //   { vehicleNumber: 'RJ14GH1111', route: 'Zone 1 - Route F', speed: '34', distance: '12.5', percentCovered: '42%' },
  //   { vehicleNumber: 'RJ14GH2222', route: 'Zone 2 - Route G', speed: '28', distance: '10.8', percentCovered: '38%' },
  //   { vehicleNumber: 'RJ14GH3333', route: 'Zone 3 - Route H', speed: '40', distance: '15.2', percentCovered: '55%' },
  //   { vehicleNumber: 'RJ14GH4444', route: 'Zone 1 - Route I', speed: '22', distance: '8.1', percentCovered: '30%' }
  // ];
  // Unauthorized/Not Mapped Vehicles Table Data
  // unauthorizedVehiclesData = [
  //   { vehicleNumber: 'RJ14JK5555', route: 'Zone 2 - Route J', status: 'Unauthorized', timestamp: '07:40 AM' },
  //   { vehicleNumber: 'RJ14JK6666', route: 'Zone 3 - Route K', status: 'Not Mapped', timestamp: '07:45 AM' },
  //   { vehicleNumber: 'RJ14JK7777', route: 'Zone 1 - Route L', status: 'Unauthorized', timestamp: '07:50 AM' }
  // ];
  // // Other Vehicles Table Data
  // othrVehData = [
  //   { vehicleNumber: 'RJ14LM8888', route: 'Zone 2 - Route M', status: 'OFF', timestamp: '07:55 AM' },
  //   { vehicleNumber: 'RJ14LM9999', route: 'Zone 3 - Route N', status: 'OFF', timestamp: '08:00 AM' },
  //   { vehicleNumber: 'RJ14LM0000', route: 'Zone 1 - Route O', status: 'OFF', timestamp: '08:05 AM' }
  // ];

  // For search/filter functionality in Alerts table
  searchText = "";
  showRegionBoundary = false;

  getAlertTagColor(type: string) {
    switch (type) {
      case "Stopage":
        return "red";
      case "Overspeed":
        return "orange";
      case "Deviation":
        return "blue";
      default:
        return "default";
    }
  }
  getAlertIcon(type: string) {
    switch (type) {
      case "Stopage":
        return "pause-circle";
      case "Overspeed":
        return "dashboard";
      case "Deviation":
        return "swap-right";
      default:
        return "alert";
    }
  }
  getWrds(tnt_id) {
    this.showLdr = true;
    this.selectedtenants = tnt_id;
    this.hasFitBounds = false;
    this.getStartedVehiclesData();
    this.getothrVehclData();
    this.getUnauthorizedVehiclesData();
    this.wardLst = [];
    this.apiServ
      .get(`playback/wards/tenant/${tnt_id}`)
      .subscribe((res: any) => {
        if (res["status"] == 200) {
          this.wardLst = res["data"];
          this.selectedward = 0;
          this.getAlertData();
        }
        this.showLdr = false;
      });
  }
  onWrdSelect(wrd_id) {
    // this.showLdr=true;
    this.selectedward = wrd_id;
    // this.apiServ.get(`playback/wards/tenant/${wrd_id}`).subscribe((res:any)=>{
    //   if(res['status']==200){
    //     this.wardLst=res['data'];
    //   }
    //   this.showLdr=false;
    // })
    this.getAlertData();
    this.getStartedVehiclesData();
    this.getothrVehclData();
    this.getUnauthorizedVehiclesData();
  }
  getAlertTypeLst() {
    this.apiServ.get(`alerts/alerts/alertType`).subscribe((res: any) => {
      if (res["status"] == 200) {
        this.AlertTypeLst = res["data"];
        this.selectedalert = [2, 4, 22, 8, 5, 21, 23];
        console.log(this.AlertTypeLst);
        this.onAlertTypeSelect(this.selectedalert);
        // this.getAlertData();
      }
    });
  }
  customTagPlaceholder = (omittedValues: any[]) => {
    return `${omittedValues.length + 1} selected`;
  };
  onAlertTypeSelect(alert_cat_id) {
    this.selectedalert = alert_cat_id;
    this.getAlertData();
  }
  // onExporting() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.
  getAlertData() {
    this.showLdr = true;
    var postData = {
      tnt_id: this.selectedtenants,
      wrd_id: this.selectedward,
      alert_cat_id: this.selectedalert,
    };
    console.log(postData);
    this.apiServ
      .post(postData, `dashboard/enterprise/alerts/getAlerts`)
      .subscribe((res: any) => {
        if (res["status"] == 200) {
          this.alertsData = res["data"];
          console.log(this.alertsData);
          this.alertsData.filter((alert: any) => {
            alert.sno = this.alertsData.indexOf(alert) + 1;
          });
          this.showLdr = false;

          this.columnDefs = [
            {
              headerName: "Sno",
              field: "sno",
              alignment: "center",
              width: 80,
              filter: false,
            },
            {
              headerName: "Vehicle Registration Number",
              field: "asrt_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Ward",
              field: "wrd_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Driver",
              field: "crw_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert",
              field: "alert_cat_nm",
              alignment: "left",
              width: "100",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert Detail",
              field: "alert_tx",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert Time",
              field: "alert_ts",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            // {
            //   headerName: 'Reason',
            //   field: 'reason',
            //   alignment: 'left',
            //   width: 180,
            //   cellTemplate: 'reasonCellTemplate',
            //   filter: false
            // },
          ];
        }
        this.showLdr = false;
        this.getAlertsOnMap();
      });
  }
  changeReason(data: any) {
    if (this.isSavingRsn) {
      return;
    }
    if (!this.perms.canUpdate()) {
      this.modal.warning({
        nzTitle: "Permission Denied",
        nzContent: "You do not have permission to update alert reasons.",
      });
      return;
    }
    // Prevent submission if already submitted
    if (data.data.sbmtd_in == 1) {
      return;
    }
    // If no reason selected, show popup and do not submit
    if (!data.data.alrt_rsn_id) {
      this.modal.warning({
        nzTitle: "Select Reason",
        nzContent: "Please select a reason before submitting.",
      });
      return;
    }
    // If OTHR selected, require custom reason
    if (
      data.data.alrt_rsn_cd === "OTHR" &&
      (!data.data.alrt_rsn_tx || !data.data.alrt_rsn_tx.trim())
    ) {
      this.modal.warning({
        nzTitle: "Enter Reason",
        nzContent: "Please enter a reason before submitting.",
      });
      return;
    }
    // If reason selected, proceed as before
    this.modal.confirm({
      nzTitle: `Are you sure Do You Want Submit Reason?`,
      nzOkText: "Yes",
      nzOkType: "primary",
      nzOnOk: () => {
        this.showLdr = true;
        this.isSavingRsn = true;
        this.apiServ
          .put(data.data, `dashboard/enterprise/alerts/changeReason`)
          .subscribe(
            (res: any) => {
              this.showLdr = false;
              this.isSavingRsn = false;
              if (res["status"] == 200) {
                this.createMessage("Success", `Reason successfully Updated`);
                this.getAlertData();
              }
            },
            () => {
              this.showLdr = false;
              this.isSavingRsn = false;
            }
          );
      },
      nzCancelText: "No",
      nzOnCancel: () => {},
    });
  }

  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }
  onReasonSelect(row: any, selectedId: any) {
    if (!row.alrt_rsns) return;
    const selected = row.alrt_rsns.find(
      (r: any) => r.alrt_rsn_id === selectedId
    );
    row.alrt_rsn_id = selectedId;
    row.alrt_rsn_cd = selected ? selected.alrt_rsn_cd : null;
    if (row.alrt_rsn_cd !== "OTHR") {
      row.alrt_rsn_tx = "";
    }
  }

  getStartedVehiclesData() {
    var postslctdDt = {
      trp_type_id: 1,
      tnt_id: this.selectedtenants,
      sts: "sts",
      id: 1,
    };
    this.startedVehiclesData = [];
    this.strtdVehiclesDatacolumnDefs = [];
    this.showLdr = true;
    let rte = `dashboard/enterprise/alerts/getVehiclesbyStaus`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          this.showLdr = false;
          console.log(res_data);
          if (res_data && res_data.length > 0) {
            this.startedVehiclesData = res["data"];

            this.strtdVehiclesDatacolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 80,
                filter: false,
                search: false,
              },
              {
                headerName: "Ward",
                field: "wrd_nm",
                alignment: "left",
                width: 120,
              },
              {
                headerName: "Vehicle registration Number",
                alignment: "left",
                width: "auto",
                field: "asrt_nm",
              },
              {
                headerName: "Route",
                alignment: "left",
                field: "rte_nm",
                width: "auto",
              },
              {
                headerName: "Driver",
                alignment: "left",
                field: "crw_nm",
                width: "auto",
              },
              {
                headerName: "Driver Contact",
                alignment: "center",
                field: "crw_ph",
                width: "auto",
              },

              {
                headerName: "Distance",
                alignment: "center",
                field: "dist",
                width: "auto",
              },
              {
                headerName: "Coverage %",
                alignment: "center",
                field: "cvrg_prcntg_ct",
                width: "auto",
              },
              {
                headerName: "Last Updated",
                alignment: "center",
                field: "last_data_rcvd",
                width: "auto",
              },
              // { headerName: 'Trip To Location', field: 'end_loc', alignment: 'center', width: 'auto' },
              // { headerName: 'Trip Start Time', alignment: 'center', field: 'actl_strt_ts', width: 'auto' },
              // { headerName: 'Trip End Time', field: 'actl_end_ts', alignment: 'center', width: 'auto' },
              // { headerName: 'Trip Status', field: 'trp_status', alignment: 'center', width: 'auto' },
              // { headerName: 'Delay In Minutes', field: 'time_diff_min', alignment: 'center', width: 'auto' },
            ];
          }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getothrVehclData() {
    var postslctdDt = {
      trp_type_id: 1,
      tnt_id: this.selectedtenants,
      sts: "sts",
      id: 2,
    };
    this.othrVehData = [];
    this.othrVehDatacolumnDefs = [];
    this.showLdr = true;
    let rte = `dashboard/enterprise/alerts/getVehiclesbyStaus`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          this.showLdr = false;
          console.log(res_data);
          if (res_data && res_data.length > 0) {
            this.othrVehData = res["data"];

            this.othrVehDatacolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 80,
                filter: false,
                search: false,
              },
              {
                headerName: "Ward",
                field: "wrd_nm",
                alignment: "left",
                width: 120,
              },
              {
                headerName: "Vehicle registration Number",
                alignment: "left",
                width: "auto",
                field: "asrt_nm",
              },
              {
                headerName: "Driver",
                alignment: "left",
                field: "crw_nm",
                width: "auto",
              },
              {
                headerName: "Driver Contact",
                alignment: "center",
                field: "crw_ph",
                width: "auto",
              },
              {
                headerName: "Current Status",
                alignment: "left",
                field: "STATUS",
                width: "auto",
              },
              {
                headerName: "Distance",
                alignment: "left",
                field: "dist",
                width: "auto",
              },
              {
                headerName: "Last Updated",
                alignment: "center",
                field: "last_data_rcvd",
                width: "auto",
              },
            ];
          }
          this.showLdr = false;
        }
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getUnauthorizedVehiclesData() {
    this.showLdr = true;
    this.unAuthVehData = [];
    this.unAuthcolumnDefs = [];
    var postData = {
      tnt_id: this.selectedtenants,
      wrd_id: this.selectedward,
      alert_cat_id: [23],
    };
    console.log(postData);
    this.apiServ
      .post(postData, `dashboard/enterprise/alerts/getAlerts`)
      .subscribe((res: any) => {
        if (res["status"] == 200) {
          this.unAuthVehData = res["data"];
          console.log(this.unAuthVehData);
          this.unAuthVehData.filter((u: any) => {
            u.sno = this.unAuthVehData.indexOf(u) + 1;
          });
          this.unAuthcolumnDefs = [
            {
              headerName: "Sno",
              field: "sno",
              alignment: "center",
              width: 80,
              filter: false,
            },
            {
              headerName: "Vehicle Registration Number",
              field: "asrt_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Ward",
              field: "wrd_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Driver",
              field: "crw_nm",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert",
              field: "alert_cat_nm",
              alignment: "left",
              width: "100",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert Detail",
              field: "alert_tx",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
            {
              headerName: "Alert Time",
              field: "alert_ts",
              alignment: "left",
              width: "auto",
              filter: true,
              sortable: true,
            },
          ];
        }
        this.showLdr = false;
      });
  }
  mapDataGrouped: {
    asrt_id: number;
    asrt_nm: string;
    lat: number;
    lng: number;
    alerts: any[];
  }[] = [];

  // Call this when the tab is switched
  // onTabChange(tabIndex: number) {
  //   // Assume map tab index is 1 (adjust if needed)
  //   if (tabIndex === 1) {
  //     // Fetch latest alerts and plot
  //     this.getAlertsOnMap();
  //     setTimeout(() => {
  //       if (this.map) {
  //         this.map.invalidateSize();
  //         this.plotAlertsOnMap();
  //       }
  //     }, 300); // Delay to ensure DOM is ready
  //   }
  // }

  getAlertsOnMap() {
    var postData = {
      tnt_id: this.selectedtenants,
      wrd_id: this.selectedward,
      alert_cat_id: this.selectedalert,
    };
    this.mapData = [];
    this.mapDataGrouped = [];
    this.apiServ
      .post(postData, `alerts/alerts/getVehicleAlerts`)
      .subscribe((res: any) => {
        if (res["status"] == 200) {
          this.mapData = res["data"];
          console.log(this.mapData, "mapdtaaaaaaaaaaaaaaaaaa");
          // Group alerts by vehicle registration number (asrt_nm)
          // Group alerts by vehicle (asrt_id + asrt_nm)
          const grouped: {
            [vehicleKey: string]: {
              asrt_id: number;
              asrt_nm: string;
              lat: number;
              lng: number;
              alerts: any[];
            };
          } = {};
          for (const alert of this.mapData) {
            const vehicleKey = alert.asrt_id + "_" + alert.asrt_nm;
            if (!grouped[vehicleKey]) {
              grouped[vehicleKey] = {
                asrt_id: alert.asrt_id,
                asrt_nm: alert.asrt_nm,
                lat: alert.lat,
                lng: alert.lng,
                alerts: [],
              };
            }
            grouped[vehicleKey].alerts.push(alert);
          }
          this.mapDataGrouped = Object.values(grouped);
          console.log("Grouped mapData by vehicle:", this.mapDataGrouped);
          this.plotAlertsOnMap();
        }
      });
    // this.socketService.listenToSocketNotifs(postData).subscribe((msg: any) => {
    //   console.log('RAW SOCKET RESPONSE:', msg);
    //   this.mapData = Array.isArray(msg?.msg) ? msg.msg : [];
    //   console.log('Parsed mapData:', this.mapData);
    //   // Fallback to dummy data for testing if empty
    //   if (!this.mapData || this.mapData.length === 0) {
    //     this.mapData = [
    //       { asrt_nm: 'RJ14PT3952', lat: 28.682079, lng: 77.442239, alert_cat_nm: 'Overspeed', alert_tx: 'Speed > 60', alert_ts: '21-08-2025 10:00' },
    //       { asrt_nm: 'RJ14PT3952', lat: 28.682079, lng: 77.442239, alert_cat_nm: 'Deviation', alert_tx: 'Route deviation', alert_ts: '21-08-2025 10:05' },
    //       { asrt_nm: 'RJ14PT3920', lat: 28.684079, lng: 77.435239, alert_cat_nm: 'Stopage', alert_tx: 'Stopped > 10min', alert_ts: '21-08-2025 10:10' }
    //     ];
    //     console.warn('No mapData from server, using dummy data for map markers!');
    //   }
    //   // Group alerts by vehicle registration number (asrt_nm)
    //   const grouped: {[vehicle: string]: { alerts: any[], lat: number, lng: number }} = {};
    //   for (const alert of this.mapData) {
    //     const vehicle = alert.asrt_nm;
    //     if (!grouped[vehicle]) {
    //       grouped[vehicle] = { alerts: [], lat: alert.lat, lng: alert.lng };
    //     }
    //     grouped[vehicle].alerts.push(alert);
    //   }
    //   this.mapDataGrouped = Object.keys(grouped).map(vehicle => ({
    //     vehicle,
    //     alerts: grouped[vehicle].alerts,
    //     lat: grouped[vehicle].lat,
    //     lng: grouped[vehicle].lng
    //   }));
    //   console.log(this.mapDataGrouped, "Grouped mapData by vehicle");
    //   this.plotAlertsOnMap();
    // });
  }

  plotAlertsOnMap() {
    // --- Smooth marker animation start ---
    if (!this.vehicleMarkerMap) this.vehicleMarkerMap = {};
    if (!this.lastVehicleApiPosition) this.lastVehicleApiPosition = {};
    if (!this.vehicleMarkerGroup) this.vehicleMarkerGroup = L.layerGroup();
    this.vehicleMarkerGroup.clearLayers();
    const visibleCatIds = this.alertCategories
      .filter((c) => c.visible)
      .map((c) => c.alert_cat_id);
    const bounds = [];
    for (const vehicleObj of this.mapDataGrouped) {
      const visibleVehicleAlerts = vehicleObj.alerts.filter((a) =>
        visibleCatIds.includes(a.alert_cat_id)
      );
      if (visibleVehicleAlerts.length === 0) continue;
      const { asrt_nm, asrt_id, alerts, lat, lng } = vehicleObj;
      console.log(alerts, "alerts");

      let popupContent = `<div style='text-align:center;'><img src='https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/${alerts[0].icon_path}' style='width:40px;height:40px;'/><br/><b>${asrt_nm}</b></div>`;
      const uniqueCategories = Array.from(
        new Map(visibleVehicleAlerts.map((a) => [a.alert_cat_id, a])).values()
      );
      popupContent += `<div style='margin-top:6px'><b>Alert Categories:</b><ul style='padding-left:18px;'>`;
      for (const alert of uniqueCategories) {
        const cat = this.alertCategories.find(
          (c) => c.alert_cat_id === alert.alert_cat_id
        );
        let iconMap: { [key: number]: string } = {
          2: "⏰", // Delay
          22: "🧭", // GPS Not Reporting
          8: "🕒", // Late Departure
          5: "🚦", // Overspeed
          4: "🔀", // Deviation
          23: "⚠️", // Unauthorized Movement
          21: "⏸️", // Vehicle Stoppage
        };
        let iconHtml = cat
          ? `<span style='font-size:18px;color:${
              cat.color
            };vertical-align:middle;'>${
              iconMap[cat.alert_cat_id] || "❗"
            }</span>`
          : `<span style='font-size:18px;color:#888;vertical-align:middle;'>❗</span>`;
        popupContent += `<li style='display:flex;align-items:center;gap:7px;'>${iconHtml} <span>${
          cat ? cat.label : ""
        }</span></li>`;
      }
      popupContent += "</ul></div>";
      const markerLat = lat || 28.680079;
      const markerLng = lng || 77.440239;
      const movIcon = new L.Icon({
        iconUrl:
          "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
          (alerts[0].icon_path || "default.png"),
        iconSize: [30, 30],
        iconAnchor: [10, 25],
        popupAnchor: [5, -24],
        shadowSize: [35, 35],
        asrt_id: asrt_id,
      });
      // --- Animation logic ---
      let marker = this.vehicleMarkerMap[asrt_id];
      if (!marker) {
        // Animate marker from map center (or a fixed point) to its first position for smooth initial plotting
        const mapCenter = this.map.getCenter();
        const startLatLng: [number, number] = [mapCenter.lat, mapCenter.lng];
        const endLatLng: [number, number] = [markerLat, markerLng];
        marker = L.marker(startLatLng, { icon: movIcon });
        marker.bindPopup(popupContent);
        this.vehicleMarkerMap[asrt_id] = marker;
        // Animate to first position
        const initialDuration = 1000; // 1s for initial fly-in
        const initialSteps = 30;
        const initialPath = interpolatePath(
          startLatLng,
          endLatLng,
          initialSteps
        );
        let initialStep = 0;
        function animateInitial() {
          if (initialStep < initialPath.length) {
            marker.setLatLng(initialPath[initialStep]);
            initialStep++;
            setTimeout(animateInitial, initialDuration / initialSteps);
          } else {
            marker.setLatLng(endLatLng);
          }
        }
        animateInitial();
        // Set last API position for future updates
        this.lastVehicleApiPosition[asrt_id] = endLatLng;
      } else {
        // Animate marker position from previous API-reported position to current, matching API interval
        const prevApiPos = this.lastVehicleApiPosition[asrt_id];
        const currApiPos: [number, number] = [markerLat, markerLng];
        const apiInterval = 10000; // ms, matches setInterval for getAlertsOnMap
        const steps = 60; // Smoothness (e.g., 6 per second)
        if (
          prevApiPos &&
          (prevApiPos[0] !== currApiPos[0] || prevApiPos[1] !== currApiPos[1])
        ) {
          // Animate from previous API position to current
          const path = interpolatePath(prevApiPos, currApiPos, steps);
          let step = 0;
          function animatePath() {
            if (step < path.length) {
              marker.setLatLng(path[step]);
              step++;
              setTimeout(animatePath, apiInterval / steps);
            } else {
              marker.setLatLng(currApiPos);
            }
          }
          animatePath();
        } else {
          // First run or no movement: place marker at current position
          marker.setLatLng(currApiPos);
        }
        marker.setIcon(movIcon);
        marker.bindPopup(popupContent);
        marker.setRotationAngle(alerts[0].direction + 270);
        // Update last API position for next animation
        this.lastVehicleApiPosition[asrt_id] = currApiPos;
      }
      this.vehicleMarkerGroup.addLayer(marker);
      bounds.push([markerLat, markerLng]);
    }
    if (this.vehicleMarkerGroup.getLayers().length > 0) {
      this.vehicleMarkerGroup.addTo(this.map);
      if (!this.hasFitBounds) {
        if (bounds.length > 0) {
          this.map.fitBounds(bounds);
          this.hasFitBounds = true;
        }
      }
    }
    // --- Smooth marker animation end ---
    console.log("Markers plotted:", this.mapDataGrouped.length);
  }
  // Ensure map is initialized
  // if (!this.map) {
  //   this.initMap();
  //   if (!this.map) {
  //     console.error('Map not initialized');
  //     return;
  //   }
  // }
  oldplotAlertsOnMap() {
    // Remove previous vehicle markers LayerGroup if exists
    if (this.vehicleMarkerGroup) {
      this.vehicleMarkerGroup.clearLayers();
      // this.map.removeLayer(this.vehicleMarkerGroup);
    }
    this.vehicleMarkerGroup = L.layerGroup();
    // Add markers for each vehicle
    const visibleCatIds = this.alertCategories
      .filter((c) => c.visible)
      .map((c) => c.alert_cat_id);
    const bounds = [];
    for (const vehicleObj of this.mapDataGrouped) {
      // Only show marker if vehicle has at least one visible alert
      const visibleVehicleAlerts = vehicleObj.alerts.filter((a) =>
        visibleCatIds.includes(a.alert_cat_id)
      );
      if (visibleVehicleAlerts.length === 0) continue;
      const { asrt_nm, asrt_id, alerts, lat, lng } = vehicleObj;
      let popupContent = `<div style='text-align:center;'><img src='https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/${alerts[0].icon_path}' style='width:40px;height:40px;'/><br/><b>${asrt_nm}</b></div>`;
      // Compose popup content with unique alert categories for this vehicle, filter by visibleCatIds
      const uniqueCategories = Array.from(
        new Map(visibleVehicleAlerts.map((a) => [a.alert_cat_id, a])).values()
      );
      popupContent += `<div style='margin-top:6px'><b>Alert Categories:</b><ul style='padding-left:18px;'>`;
      for (const alert of uniqueCategories) {
        const cat = this.alertCategories.find(
          (c) => c.alert_cat_id === alert.alert_cat_id
        );
        let iconMap: { [key: number]: string } = {
          2: "⏰", // Delay
          22: "🧭", // GPS Not Reporting
          8: "🕒", // Late Departure
          5: "🚦", // Overspeed
          4: "🔀", // Deviation
          23: "⚠️", // Unauthorized Movement
          21: "⏸️", // Vehicle Stoppage
        };
        let iconHtml = cat
          ? `<span style='font-size:18px;color:${
              cat.color
            };vertical-align:middle;'>${
              iconMap[cat.alert_cat_id] || "❗"
            }</span>`
          : `<span style='font-size:18px;color:#888;vertical-align:middle;'>❗</span>`;
        popupContent += `<li style='display:flex;align-items:center;gap:7px;'>${iconHtml} <span>${
          cat ? cat.label : ""
        }</span></li>`;
      }
      popupContent += "</ul></div>";
      // Fallback to demo marker if no coordinates
      const markerLat = lat || 28.680079;
      const markerLng = lng || 77.440239;
      // Use vehicle icon from backend for marker
      const movIcon = new L.Icon({
        iconUrl:
          "https://cdmavts.wetrackon.com/assets/images/markers/mapIcons/m/" +
          (alerts[0].icon_path || "default.png"),
        iconSize: [51, 51],
        iconAnchor: [10, 25],
        popupAnchor: [5, -24],
        shadowSize: [35, 35],
        asrt_id: asrt_id,
      });
      // Animated marker logic
      let animatedMarker = null;
      // Check if we have previous lat/lng for this vehicle
      if (
        this.m_prv_lat &&
        this.m_prv_lng &&
        this.m_prv_lat[asrt_id] != null &&
        this.m_prv_lng[asrt_id] != null &&
        lat != null &&
        lng != null &&
        (this.m_prv_lat[asrt_id] !== lat || this.m_prv_lng[asrt_id] !== lng)
      ) {
        // Animate from previous to current
        const line = [
          [this.m_prv_lat[asrt_id], this.m_prv_lng[asrt_id]],
          [lat, lng],
        ];
        const iconAngle = alerts[0].direction || 0;
        animatedMarker = L.animatedMarker(line, {
          icon: movIcon,
          autoStart: false,
        })
          .setRotationAngle(iconAngle)
          .bindPopup(popupContent);
        animatedMarker.start();
        this.m_prv_lat[asrt_id] = lat;
        this.m_prv_lng[asrt_id] = lng;
      } else {
        // Fallback to static marker if not enough data
        var marker = L.marker([markerLat, markerLng], {
          icon: movIcon,
        });
        marker.bindPopup(popupContent);
        this.m_prv_lat = this.m_prv_lat || {};
        this.m_prv_lng = this.m_prv_lng || {};
        this.m_prv_lat[asrt_id] = lat;
        this.m_prv_lng[asrt_id] = lng;
      }
      let m = animatedMarker || marker;
      if (m) {
        this.vehicleMarkerGroup.addLayer(m);
        bounds.push([markerLat, markerLng]);
      }
    }
    if (this.vehicleMarkerGroup.getLayers().length > 0) {
      this.vehicleMarkerGroup.addTo(this.map);
      if (bounds.length > 0) {
        this.map.fitBounds(bounds);
      }
    }
    console.log("Markers plotted:", this.mapDataGrouped.length);
  }

  // // Example alertCategories config (move to ngOnInit or service)
  // alertCategories = [
  //   { alert_cat_id: 2, icon: 'clock-circle', color: '#8e44ad', label: 'Delay', visible: true },
  //   { alert_cat_id: 22, icon: 'compass', color: '#34495e', label: 'GPS Not Reporting', visible: true },
  //   { alert_cat_id: 8, icon: 'field-time', color: '#2ecc71', label: 'Late Departure', visible: true },
  //   { alert_cat_id: 5, icon: 'dashboard', color: '#e74c3c', label: 'Overspeed', visible: true },
  //   { alert_cat_id: 4, icon: 'swap-right', color: '#2980b9', label: 'Deviation', visible: true },
  //   { alert_cat_id: 23, icon: 'exclamation-circle', color: '#f39c12', label: 'Unauthorized Movement', visible: true },
  //   { alert_cat_id: 21, icon: 'pause-circle', color: '#f39c12', label: 'Vehicle Stoppage', visible: true },
  //   // Add more as needed
  // ];

  // Always show region boundary if toggled
  private plotRegionBoundary() {
    if (this.showRegionBoundary && this.regionBoundary) {
      if (this.regionPolygon) this.map.removeLayer(this.regionPolygon);
      this.regionPolygon = L.polygon(this.regionBoundary, {
        color: "#3388ff",
        fillOpacity: 0.1,
        weight: 3,
      }).addTo(this.map);
    } else if (this.regionPolygon && this.map.hasLayer(this.regionPolygon)) {
      this.map.removeLayer(this.regionPolygon);
    }
  }

  toggleCategory(cat: any) {
    this.plotAlertsOnMap();
  }
}
